<template>
  <!-- https://developers.google.com/search/docs/appearance/structured-data/breadcrumb#microdata  - HASZNOS LINK-->
  <ul
    class="list-unstyled py-1 py-sm-2 py-lg-3 m-0 breadcrumb align-items-center mt-5"
    itemprop="breadcrumbList"
    itemscope
    itemtype="https://schema.org/BreadcrumbList"
  >
    <li
      v-for="(route, index) in elements"
      :key="index"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
      class="mx-1"
    >
      <router-link
        v-if="'path' in route || 'name' in route"
        class="pointer"
        itemprop="item"
        :class="{'force-pointer': singleElement}"
        :to="goToPage(route)"
      >
        <span itemprop="name" v-text="route.title" />
      </router-link>
      <span
        v-else
        itemprop="name"
        v-text="route.title"
      />
      <i class="bi bi-chevron-double-right ms-1" />
      <meta itemprop="position" :content="index">
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    /**
     * A breadcrumb elemei. Ha nincs hozzá path, akkor nem lesz belőle link (utolsó elem pl)
     * path vagy router name is lehet (vagy ez vagy az).
     *
     * @type {{
     *   name: string | undefined,
     *   path: ?string | undefined,
     *   title: string,
     * }[]}
     */
    elements: {
      type: Array,
      required: true,
    },
    /**
     * Csak egy elemű - ilyenkor módosul a design
     */
    singleElement: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * Navigálás a megadott oldalra.
     *
     * @param {{
     *   path: ?string,
     *   name: string,
     *   params: ?{},
     * }} route
     */
    goToPage(route) {
      let ret = {}
      if (route.name !== undefined) {
        ret = { name: route.name }
      }
      if (route.params !== undefined) {
        ret = { ...ret, params: { ...route.params } }
      }

      if (ret.name !== undefined) {
        return ret
      }

      return route.path
    },
  },
}

</script>

<style scoped lang="scss">
.breadcrumb {
  display: flex;
  background-color: transparent;
  font-size: 0.9375rem;
  padding-left: 0;
  padding-right: 0;

  .pointer {
    cursor: pointer;
  }

  li {
    margin-right: 1.125rem;

    a {
      text-decoration: unset;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.25rem;
      letter-spacing: 0.02em;
      text-align: left;
      color: #606060;

      &:hover {
        color: #2f9f9c;
      }
    }

    &:last-child span {
      font-weight: 600;
      color: var(--main-theme-color);
    }

    &:last-child {
      i {
        display: none;
      }
    }

    &:nth-last-child(2) {
      i {
        color: var(--main-theme-color);
      }
    }

    &:last-child a:not(.force-pointer) {
      cursor: auto;

      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
